export enum AccessPaths {
  Content = 'content',
  Requests = 'requests',
}
